export default __webpack_public_path__ + "static/media/song1.8d7afa73.mp3";